// LiquidCard.jsx
import React from "react";
import "../styles/components/LiquidCard.scss";

export default function LiquidCard({ icon, title, text, index, active, onClick }) {
  return (
    <div
      className={`liquid-card card-anim card-anim-${index % 2 === 0 ? "a" : "b"}${active ? " active" : ""}`}
      style={{ "--i": index }}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={e => (e.key === "Enter" || e.key === " ") && onClick()}
      role="button"
      aria-pressed={active}
    >
      <div className="liquid-card__icon">{icon}</div>
      <h3 className="liquid-card__title">{title}</h3>
      <p className="liquid-card__text">{text}</p>
    </div>
  );
}



